<template>
  <div class="container">
    <!-- banner -->
    <div class="index_top">
      <div class="top_logo">
        <div class="logo_img">
          <div class="logo_imgV">
            <img style="cursor: pointer" @click="routerTo('/')"
                 src="../../assets/images/crest.png" alt>
          </div>
          <div class="logo_title">
            <div class="logo_title1" style="height: 50px;" v-if="navData.name != '河北东方学院'">
              <span>{{ navData.name }}</span>
            </div>
            <div class="logo_title1" style="height: 50px;" v-if="navData.name == '河北东方学院'">
              <span></span>
            </div>
            <div style="height: 50px;transform: translateY(-20px)">
              <img @click="erJi" style="cursor: pointer; width: 100%;transform: translateY(-30px) scale(0.95)"
                   src="../../assets/images/校训-字体.png"
                   alt>
            </div>
          </div>
        </div>
        <div class="logo_search">
          <div class="header_li_con">
              <img style="cursor: pointer;transform: scale(0.9) translateY(-20px) translateX(-10px)"
                   src="../../assets/images/办学理念字体.png">
          </div>
          <div class="ipt">
            <input v-model="iptVal" class="ipt_" type="text" placeholder="搜索" @keydown.enter="handleKeyDown">
            <img @click="navSearch('')" src="../../assets/images/search.png" alt>
          </div>
          <div class="gateway">
            <a href="https://hbdfxy.hall.chaoxing.com" target="_blank">智慧校园信息门户</a>
          </div>
        </div>
      </div>
      <div class="top_menu" v-if="!navigation">
        <ul class="one">
          <li
            v-if="pagePath == '/' || pagePath == '/home' || pagePath == '/organization' || pagePath == '/search'"><span
            @click="routerTo('/')">首页</span></li>
          <li v-for="(item,index) in navChildData" :key="index" :class="item.placeType == 4 ? 'active' : ''">
            <span v-if="item.placeType == 3" @click="routerpush(item)">{{ item.name }}</span>
            <div v-if="item.placeType == 1">
              <!--              <el-cascader-->
              <!--                v-model="value"-->
              <!--                :options="item.children"-->
              <!--                @change="handleChange"-->
              <!--                :props="{-->
              <!--                     expandTrigger: 'hover',-->
              <!--                      value:'id',-->
              <!--                      label:'name'-->
              <!--                }"-->
              <!--              ></el-cascader>-->

              <!--              <el-cascader  popper-class="el-cascader" :options="item.children">-->
              <!--                <template slot-scope="{ node, data }">-->
              <!--                  <span>{{ data.name }}</span>-->
              <!--&lt;!&ndash;                  <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>&ndash;&gt;-->
              <!--                </template>-->
              <!--              </el-cascader>-->

              <el-dropdown class="dropdown">
                <span style="font-size: 16px" class="el-dropdown-link">
                  {{ item.name }}<i class=""></i>
                </span>
                <el-dropdown-menu class="dropdown_menu" style="width: 140px;">
                  <el-dropdown-item class="el-dropdown-item" v-for="(item1,index1) in item.children" :key="index1">
                    <div id="twoMenu" @click="routerpush(item1)" @mouseenter="hoveredSubMenu = item1"
                         @mouseleave="hoveredSubMenu = null">
                      {{ item1.name }}
                      <el-dropdown-item class="el-dropdown-item" v-for="(item2,index2) in item1.children" :key="index2"
                                        v-if="hoveredSubMenu  === item1 && item1.placeType == '1'">
                        <div v-if="hoveredSubMenu === item1" class="threeMenuContainer">
                          <div v-for="(item2, index2) in item1.children" :key="index2" class="threeMenu"
                               :style="{ top: (index2 * 40) + 'px' }">
                            <div @click="routerpush(item2)" @mouseenter="hoveredSubMenu3 = item2"
                                 @mouseleave="hoveredSubMenu3 = null">
                              {{ item2.name }}

                              <el-dropdown-item class="el-dropdown-item" v-for="(item3,index3) in item2.children"
                                                :key="index3"
                                                v-if="hoveredSubMenu3  === item2 && item2.placeType == '1'">
                                <div v-if="hoveredSubMenu3 === item2" class="threeMenuContainer">
                                  <div v-for="(item3, index3) in item2.children" :key="index3" class="threeMenu"
                                       :style="{ top: (index3 * 40) + 'px' }">
                                    <div @click="routerPushChild(item3)">
                                      {{ item3.name }}
                                    </div>
                                  </div>
                                </div>
                              </el-dropdown-item>
                            </div>
                          </div>
                        </div>
                      </el-dropdown-item>
                    </div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>


            </div>
          </li>
<!--          <li style="text-align: right"><span><a href="https://hbdfxy.hall.chaoxing.com">统一校园门户</a></span></li>-->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import home from '../../api/home.js'

export default {
  name: 'navtop',
  components: {},
  props: ['parentData', 'navigation'],
  data () {
    return {
      value: [],
      hoveredSubMenu: null, // 当前鼠标悬浮的二级菜单项
      hoveredSubMenu3: null, // 三级
      // 搜索框内容
      iptVal: '',
      // 导航数据
      navData: {},
      navChildData: [],
      nalistshowflag: false,
      // 页面路径
      pagePath: ''
    }
  },
  computed: {
    formattedOptions () {
      // 将原始数据格式化为el-cascader可接受的数据格式
      return this.item.map(item => ({
        label: item.name,
        value: item.value,
        children: item.children ? item.children.map(child => ({
          label: child.name,
          value: child.value,
          children: child.children ? child.children.map(grandchild => ({
            label: grandchild.name,
            value: grandchild.value
          })) : []
        })) : []
      }))
    }
  },
  created () {
    this.getNav() // 导航
    this.pagePath = this.removeAfterFirstNumber(this.$route.path)
    console.log(this.$route.path, 'path')
  },
  mounted () {

  },
  watch: {
    '$route': function (newRoute, oldRoute) {
      // 路由变化时执行的操作
      this.pagePath = this.removeAfterFirstNumber(this.$route.path)
      // console.log(this.$route.path, 'pathpathpath')
    }
  },
  methods: {
    // 点击二级
    erJi () {
      console.log(this.navData.path, 'pathpathpath')
      if (this.navData.path.startsWith('https') || this.$route.path == '/') {
        return
      }
      if (this.navData.path == '/thematic/education' || this.navData.path == '/common/more') {
        this.$router.push('/')
        return
      }
      if (this.navData.path == '/convention') {
        this.$router.push('/')
        return
      }
      this.$router.push(this.navData.path + '/' + this.navData.id)
    },
    // 点击回车搜索
    handleKeyDown (e) {
      if (e.key === 'Enter') {
        this.navSearch()
      }
    },
    // 点击搜索
    navSearch () {
      // console.log(this.$route.query.search,'serrch')
      console.log(this.iptVal, '搜索之')
      if (this.iptVal == this.$route.query.search) {
        window.location.reload()
        return
      }
      if (!this.iptVal) {
        window.location.href = 'https://www.baidu.com/'
        return
      }
      if (this.iptVal) {
        this.$router.push({path: '/search' + '/' + this.iptVal})
      }
    },
    // 跳转
    routerTo (path) {
      if (this.$route.path === path) {
        window.location.reload()
        return
      }
      this.$router.push(path)
    },

    // 跳转处理
    routerpush (item) {
      if (item.path == this.$route.path) {
        window.location.reload()
        return
      }
      if (item.pathType == 0) {
        return
      }
      if (item.pathType == 2) {
        window.open(item.path, '_blank')
        return
      }
      if (item.appointTabId) {
        // const [firstNumber, secondNumber] = this.extractFirstAndSecondNumbers(item.appointTabId)
        // this.$router.push(item.path + '/' + firstNumber + '/' + secondNumber)
        let encodedId = encodeURIComponent(item.appointTabId)
        let decodedId = decodeURIComponent(encodedId)
        this.$router.push(item.path + decodedId)
        return
      }
      if (item.path == '/common/section/more') {
        this.$router.push(item.path + '/' + item.parentId + '/' + item.id)
        return
      }
      if (item.tabBarId) {
        this.$router.push({path: item.path + '/' + item.tabBarid})
        return
      }
      if (!item.tabBarId) {
        if (item.path == '/home' || item.path == '/organization') {
          this.$router.push({path: item.path})
          return
        }
        this.$router.push({path: item.path + '/' + item.id})
        return
      }
    },

    // 二级列表处理跳转
    routerPushChild (item) {
      // 设置当前激活的二级菜单项
      this.activeSubMenu = item
      console.log(item, 'llll')
      if (item.pathType == 2) {
        window.open(item.path, '_blank')
        console.log('2222')
        return
      }
      // 生成路由路径
      let routePath = item.path
      if (item.appointTabId) {
        routePath += item.appointTabId
      } else if (item.tabBarId) {
        routePath += '/' + item.tabBarId
      } else if (!item.tabBarId) {
        routePath += '/' + item.id
      } else if (item.path != null) {
        routePath = '/common/section/more/' + item.parentId + '/' + item.id
      }
      console.log(item, 'itemitem')
      console.log(routePath, 'pathpath')
      // 使用router.resolve来生成完整的URL
      const resolvedRoute = this.$router.resolve(routePath)
      // 在新标签页中打开路由
      window.open(resolvedRoute.href, '_blank')
    },

    // 获取导航栏
    async getNav () {
      try {
        // console.log(this.parentData,111)
        if (this.parentData) {
          const res = await home.getNav({id: this.parentData})
          if (res.code == 200) {
            this.$nextTick(() => {
              // 这里可以安全地操作DOM
              this.navData = res.data
              console.log(this.navData)
              this.navChildData = res.data.children
              console.log(res.data)
            })
          }
        } else {
          const res = await home.getNav({id: 1})
          if (res.code == 200) {
            this.navData = res.data
            this.navChildData = res.data.children
          }
        }
      } catch (e) {
        console.error(e)
      }
    },

    // 过滤路径
    removeAfterFirstNumber (url) {
      // 查找第一个数字的位置
      const firstNumberIndex = url.search(/\d/)

      // 如果找到了数字，截取数字之前的内容，否则返回原始字符串
      return firstNumberIndex !== -1 ? url.substring(0, firstNumberIndex - 1) : url
    },
    // 匹配数字
    extractFirstAndSecondNumbers (str) {
      // 正则表达式匹配数字
      const regex = /\d+/g
      let match
      let numbers = []

      // 使用正则表达式的exec方法来循环匹配所有数字
      while ((match = regex.exec(str)) !== null) {
        numbers.push(match[0])
      }

      // 返回第一个和第二个数字，如果没有足够的数字则返回undefined
      return [numbers[0], numbers[1]]
    }
  }
}
</script>

<style lang="less" scoped>
body {
  font: 16px / 1 'Tahoma', 'Helvetica', '微软雅黑', '宋体', sans-serif;
}
a{
  text-decoration: none;
  color: #fff;
}

/deep/ .el-tag.el-tag--info {
  background-color: #123493;
  border-color: rgba(57, 106, 254, 1);
  color: #FFFFFF;
}

/deep/ .el-cascader__tags .el-tag:not(.is-hit) {
  border-color: rgba(57, 106, 254, 1);
}

::v-deep {
  .el-cascader {
    width: 100%;

    .el-input__wrapper {
      padding: 0;
      box-shadow: none;
      background-color: transparent;

      .el-input__inner {
        -webkit-text-fill-color: inherit;
        color: inherit;
        cursor: text;
      }

      .el-input__suffix {
        display: none;
      }
    }
  }
}

.el-cascader .el-input {
  border: none; /* 去掉输入框的边框 */
  background-color: transparent; /* 去掉输入框的背景色 */
}

.el-cascader .el-input .el-input__suffix {
  display: none; /* 去掉下拉箭头 */
}

.el-cascader .el-cascader-panel {
  border: none; /* 去掉面板的边框 */
  box-shadow: none; /* 去掉面板的阴影 */
}

#twoMenu {
  position: relative;

  .threeMenuContainer {
    position: absolute;
    top: 0;
    left: 100%;
    width: 145px;
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    background-color: #ffffff;
    font-size: 13px;
    color: #6a6a6a;
    border-left: 1px solid rgba(255, 255, 255, 0.5);
  }

  .threeMenu {
    width: 100%; /* Full width of the container */
    /* Add other styles if needed */
  }

  .threeMenu:hover {
    background-color: #9e070e;
    color: #FFFFFF;
  }

  //#threeMenu {
  //  float: right;
  //  width: 130px;
  //  //max-height: 300px;
  //  position:absolute;
  //  //top: -10px;
  //  left: 100%;
  //  display: flex;
  //  flex-direction: column;
  //  margin: 10px 0;
  //  background-color: #bd0000;
  //  font-size: 13px;
  //  color: #6a6a6a;
  //  border-left: 1px solid rgba(255, 255, 255, 0.5);
  //
  //
  //  &:hover {
  //    background-color: #9e070e;
  //    color: #FFFFFF;
  //  }
  //}
}


.container {
  .index_top {
    min-width: 1200px;
    height: 160px;
    background-image: url(../../assets/images/banner.png);
    background-size: 100% 100%;

    .top_logo {
      width: 1200px;
      margin: 0 auto;
      height: 120px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo_img {
        display: flex;
        align-items: center;
        width: 819px;


        .logo_imgV {
          height: 90px;
          display: block;

          img {
            width: 364px;
            height: 90px;
          }
        }


        .logo_title {
          font-size: 32px;
          color: #fff;
          position: relative;
          margin-left: 25px;
          width: 404px;
          height: 111px;
          padding-left: 25px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          border-left: 1px solid rgba(255, 255, 255, 0.5);

          .logo_title1 {
            font-size: 28px;
            transform: translateY(10px);
          }
        }
      }

      .logo_search {
        width: 381px;
        height: 85px;

        .header_li_con {
          width: 375px;
          height: 40px;

          img {
            display: block;
            transform: translateY(-30px) translateX(20px);
          }
        }

        .ipt {
          width: 350px;
          height: 32px;
          position: relative;

          .ipt_ {
            width: 370px;
            height: 100%;
            padding: 0 20px;
            outline: none;
            border: none;
            list-style: none;
            border-radius: 25px;
            font-size: 14px;
          }

          img {
            position: absolute;
            top: 50%;
            left: 99%;
            transform: translate(-50%, -50%);
            width: 25px;
            height: 25px;

            &:hover {
              cursor: pointer;
            }
          }
        }

        .gateway{
          width: 375px;
          text-align: right;
          font-size: 13px;
          //line-height: 20px;
          padding: 5px 20px;
          //margin: 10px 0;
        }
      }
    }

    .top_menu {
      background-color: #8d080e;

      .one {
        width: 1200px;
        margin: 0 auto;
        display: flex;
        flex-wrap: nowrap;
        justify-content: start;
        align-items: center;
        height: 100%;
        color: #fff;
        font-size: 16px;

        li {
          position: relative;

          &:hover {
            background-color: #9e070e;
          }

          span {
            display: inline-block;
            height: 40px;
            line-height: 40px;
            padding: 0 20px;
            color: #fff;
            text-decoration: none;
            white-space: nowrap;
            cursor: pointer;
          }
        }
      }
    }
  }
}

// 其他样式
.active {
  display: none !important;
}

ul, li {
  list-style: none;
}
</style>
<style lang="less" scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}

.dropdown_menu {
  transform: translate(0, -6%);
  width: 120px;

  .el-dropdown-menu__item {
    text-align: center;
    padding: 0;
  }

  .el-dropdown-menu__item:hover {
    background-color: #8d080e !important;
    color: #fff !important;
  }
}

.dropdown {

}

.dropdown:hover {
  background-color: #9e070e;
}

</style>



// WEBPACK FOOTER //
// src/components/comcomponents/NavTop.vue